<template>
  <div class="studyTask-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm">
            <el-form-item label="文件类型">
              <el-select v-model="searchForm.kindId" style="width: 120px" @keyup.enter.native="searchNotice" filterable
                clearable>
                <el-option v-for="(kind, index) in kindList" :key="index" :label="kind.name" :value="kind.id" />
              </el-select>
            </el-form-item>
            <el-form-item label="搜索关键字">
              <el-input v-model="searchForm.search" placeholder="关键字搜索" @keyup.enter.native="searchNotice"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="searchNotice">搜索</el-button>
            </el-form-item>
          </el-form>

          <div class="card-content">
            <el-table :data="noticeData" stripe :row-style="{cursor: 'pointer'}" @row-click="openDetails"
              v-loading="loading" style="width: 100%">
              <el-table-column label="通知标题" min-width="200" show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-tag size="mini" v-if="scope.row.read===1">已读</el-tag>
                  <el-tag type="danger" size="mini" v-if="scope.row.read===0">未读</el-tag>
                  <span>{{ scope.row.title }}</span>
                </template>
              </el-table-column>
              <el-table-column width="170" align="center" label="发布部门">
                <template slot-scope="scope">
                  <span>{{ scope.row.deptName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="发布时间" width="200">
                <template slot-scope="scope">
                  <span class="deadline">{{ scope.row.createTime }}</span>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination v-if="total > 0" background @size-change="handleSizeChange"
              @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[20, 50, 100]"
              :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import {
    getUser
  } from '@/utils/auth'

  import {
    getFileKinds,
    getFileNotice
  } from '@/api/archive'

  export default {
    name: 'file_notice_list',
    data() {
      return {
        kindList: [],
        noticeData: [],

        sort: 0,
        pageSize: 20,
        currentPage: 1,
        total: 0,

        loading: false,
        searchForm: {
          search: '',
          kindId: ''
        }
      }
    },
    computed: {
      user: getUser
    },
    created() {
      this.getNoticeData()
      this.getKinds()
    },
    methods: {
      getNoticeData() {
        const data = {
          page: this.currentPage,
          limit: this.pageSize,
          userId: this.user.dUserid || this.user.userid || '',
          dealerId: this.user.delid || '',
          kindId: this.searchForm.kindId,
          search: this.searchForm.search,
        }
        this.loading = true
        getFileNotice(data).then(response => {
          this.noticeData = response.data.list || []
          this.total = response.data.total || 0
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
      },
      getKinds() {
        const _this = this
        getFileKinds().then(response => {
          this.kindList = response.data || []
        })
      },
      change(sort) {
        this.typeId = sort
        this.getNoticeData()
      },
      handleSizeChange(val) {
        this.pageSize = val
        this.currentPage = 1
        this.getNoticeData()
      },
      handleCurrentChange(val) {
        this.currentPage = val
        this.getNoticeData()
      },
      searchNotice() {
        this.currentPage = 1
        this.getNoticeData()
      },
      openDetails(row) {
        this.$router.push({
          path: '/notice/file_notice_detail/' + row.id
        });
        row.read = 1
      },

    }
  }
</script>

<style lang="scss" scoped>
  .studyTask-container {
    .tcf-row {
      .card {
        .card-body {
          .card-title {
            .study-leader {
              color: #f3ad49;
              font-weight: 500;
            }
          }

          .card-content {
            .task-filter {
              width: 100%;
              padding: 0 30px 0 0;
              margin: 10px 0 0 0;
              position: relative;

              li {
                width: 100%;
                list-style: none;
                position: relative;
                padding-left: 20px;
                padding-top: 15px;
                padding-bottom: 15px;
                cursor: pointer;
                border-radius: 2px;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;

                &.active {
                  background: #f5f7fa;
                  color: #409EFF;
                }

                &:hover {
                  color: #409EFF;
                }
              }
            }

            .el-table::before {
              height: 0 !important;
            }

            .el-pagination {
              margin-top: 20px;
            }
          }
        }
      }
    }
  }

  .search-mode {
    float: right;
    width: 300px;

    .search-input {
      background-color: #F2F6FC;
      border: 0;
      height: 32px;
      line-height: 32px;
      border-radius: 4px;
      color: #606266;
      padding: 0 40px 0 15px;
      -webkit-appearance: none;
      font-size: 12px;
      width: 100%;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      outline: 0;

      &::-webkit-input-placeholder {
        color: #C0C4CC;
      }

      &::-ms-input-placeholder {
        color: #C0C4CC;
      }
    }

    .search-btn {
      position: absolute;
      right: 0;
      height: 32px;
      width: 40px;
      line-height: 32px;
      top: 0;
      border: 0;
      background: transparent;
      text-align: center;
      padding: 0;
    }
  }
</style>
